import React, { useContext, useState } from "react";
import Input from "../UI/Input";
import AppContext from "../../store/app-context";

import styles from "./QuoteRequestDetails.module.css";

const QuoteRequestDetails = (props) => {
  const appCtx = useContext(AppContext);

  let label_dateQuoteNeeded = 'Date Quote Needed';
  let label_pPlan = 'Purchase Plan';
  let label_rfqFor = 'Quote request is for';
  let label_grantApp = 'Grant Application';
  let label_newLab = 'New Lab';
  let label_comments = 'Comments';
  let label_usCurrency= 'I prefer to use United States currency for this quote';
  let label_commentsRequired = 'For empty quote, comments are required';
  let label_pp_immediately="Immediately";
  let label_pp_1_3_months="1 to 3 months";
  let label_pp_6_months="6 months";
  let label_pp_more_than_6_months="More than 6 months";
  let label_commentsInvalidChars = 'Comments has invalid characters';
  let label_quoteCommentsSpecialCharsMsg = 'Please do not use special characters: % < > "';

  if(appCtx && appCtx.bioradResources){
    label_dateQuoteNeeded = appCtx.bioradResources.Date_Quote_Needed ? appCtx.bioradResources.Date_Quote_Needed : 'Date Quote Needed';
    label_pPlan = appCtx.bioradResources.Purchase_Plan ? appCtx.bioradResources.Purchase_Plan : 'Purchase Plan';
    label_rfqFor = appCtx.bioradResources.Is_Quote_Request ? appCtx.bioradResources.Is_Quote_Request : 'Quote request is for';
    label_grantApp = appCtx.bioradResources.Grant_Application ? appCtx.bioradResources.Grant_Application : 'Grant Application';
    label_newLab = appCtx.bioradResources.New_Lab ? appCtx.bioradResources.New_Lab : 'New Lab';
    label_comments = appCtx.bioradResources.Comments ? appCtx.bioradResources.Comments : 'Comments';
    label_usCurrency= appCtx.bioradResources.US_price_quote ? appCtx.bioradResources.US_price_quote : 'I prefer to use United States currency for this quote';
    label_commentsRequired = appCtx.bioradResources.Comments_Required ? appCtx.bioradResources.Comments_Required : 'For empty quote, comments are required';
    label_pp_immediately= appCtx.bioradResources.PP_Immediately ? appCtx.bioradResources.PP_Immediately : "Immediately";
    label_pp_1_3_months= appCtx.bioradResources.PP_1_3_Months ? appCtx.bioradResources.PP_1_3_Months : "1 to 3 months";
    label_pp_6_months= appCtx.bioradResources.PP_6_Months ? appCtx.bioradResources.PP_6_Months : "6 months";
    label_pp_more_than_6_months= appCtx.bioradResources.PP_More_Than_6_Months ? appCtx.bioradResources.PP_More_Than_6_Months : "More than 6 months";
    label_commentsInvalidChars = appCtx.bioradResources.Invalid_Chars ? appCtx.bioradResources.Invalid_Chars : 'Comments has invalid characters';
    label_quoteCommentsSpecialCharsMsg = appCtx.bioradResources.Quote_Comments_Special_Chars ? appCtx.bioradResources.Quote_Comments_Special_Chars : 'Please do not use special characters: % < > "';
  }

  const [comments, setComments] = useState("");
  const [commentsTouched, setCommentsTouched] = useState(false);
  const [isInvalidComments, setIsInvalidComments] = useState(false);
  const [invalidChar, setInvalidChar] = useState(null);
  const [isEmoji, setIsEmoji] = useState(false);

  const invalidCharRegex = /[^\p{L}\p{N}\p{P}\p{Z}\p{Sc}\n]|[<>%"]/u;

  const hasLineItems = props.quote && props.quote.quoteLineEntityList && props.quote.quoteLineEntityList.length > 0;

  const commentsInputIsValid = hasLineItems ? hasLineItems : comments.trim() !== "";

  let commentsInputIsInvalid = commentsTouched
    ? !commentsInputIsValid
    : props.invalidFieldList && props.invalidFieldList.comments;

  const commentsInputChangeHandler = (event) => {
    setComments(event.target.value);
    setCommentsTouched(true);
    const invalidCharacter = invalidCharRegex.exec(event.target.value);
    setIsInvalidComments(false);
    setIsEmoji(false);
    if(invalidCharacter){
      setIsInvalidComments(true);
      if(/\p{Emoji}/u.test(invalidCharacter[0])){
        setInvalidChar(invalidCharacter[0].codePointAt(0).toString(16))
        setIsEmoji(true);
      }else {
        setInvalidChar(invalidCharacter[0])
      }
    }
  };

  const commentsInputBlurHandler = (event) => {
    setCommentsTouched(true);
    setIsInvalidComments(invalidCharRegex.test(event.target.value));
  };

  const currDate = new Date();
  currDate.setDate(currDate.getDate());
  var date = currDate.toISOString().substring(0, 10);
  return (
    <div className={styles.rfqForm}>
      <div className={styles.newInput}>
        <Input
          label={label_dateQuoteNeeded}
          input={{
            id: "date",
            type: "date",
            name: "dateQuoteNeeded",
            defaultValue: date,
          }}
        />
      </div>
      <div className={styles.purchasePlan}>
        <label htmlFor="ppPlan">{label_pPlan}</label>
        <select id="ppPlan" name="ppPlan">
          <option value="PP_Immediately">{label_pp_immediately}</option>
          <option value="PP_1_3_Months">{label_pp_1_3_months}</option>
          <option value="PP_6_Months">{label_pp_6_months}</option>
          <option value="PP_More_Than_6_Months">{label_pp_more_than_6_months}</option>
        </select>
      </div>
      <div className={styles.grantApp}>
        <span>{label_rfqFor}</span>
        <Input
          input={{
            id: "grant",
            name: "grant",
            type: "checkbox",
          }}
          label={label_grantApp}
        />
        <Input
          input={{
            id: "lab",
            name: "lab",
            type: "checkbox",
          }}
          label={label_newLab}
        />
      </div>
      <div>
        <label htmlFor="comments">{label_comments}</label>
        <textarea maxlength="2000" name="comments" id="comments" onChange={commentsInputChangeHandler} onBlur={commentsInputBlurHandler}/>
        <span>{label_quoteCommentsSpecialCharsMsg}</span>
        {commentsInputIsInvalid && (
          <p className={styles.errormsg}>{label_commentsRequired}</p>
        )}
        {((props.isInvalidComments || isInvalidComments) && !isEmoji) && (
          <p className={styles.errormsg}>{invalidChar ? label_commentsInvalidChars + ' ' + invalidChar : label_commentsInvalidChars}</p>
        )}
        {((props.isInvalidComments || isInvalidComments) && isEmoji) && (
          <p className={styles.errormsg}>{invalidChar ? label_commentsInvalidChars + ' ' + String.fromCodePoint('0x'+invalidChar) : label_commentsInvalidChars}</p>
        )}
      </div>
      {props.quote && props.quote.prefersCurrencyInUSD && (
        <div className={styles.quoteCurrency}>
          <Input
            input={{
              id: "usp",
              name: "usp",
              type: "checkbox",
            }}
           label={label_usCurrency}
          />
        </div>
      )}
    </div>
  );
};

export default QuoteRequestDetails;
